<template>
	<div class="main">
    <section class="panel" v-if="isShowTreaty">
      <treaty :key="$route.fullPath" type="relief"></treaty>
    </section>
		<section class="panel" v-else>
			<div class="panel-body container-fluid">
				<div class="row form-group">
					<div class="col-md-3 form-group">
						<label for="name" class="col-sm-4 col-xs-2 column-required">姓名</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.name}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="name" name="name" v-validate="'required'" v-model="stu.name" type="text" class="form-control" maxlength="20"/>
							<span class="text-danger" v-show="errors.has('name')">{{ errors.first('name') }}</span>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="sex" class="col-sm-4 col-xs-2 column-required">性別</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.sex == 'M' ? '男' : '女'}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="sex" name="sex" ref="sex" v-validate="'required'" v-model="stu.sex" class="form-control">
								<option value="">請選擇</option>
								<option value="M">男</option>
								<option value="F">女</option>
							</select>
							<span class="text-danger" v-show="errors.has('sex')">{{ errors.first('sex') }}</span>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="account" class="col-sm-4 col-xs-2">學號</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.account}}</div>
						<div v-else-if="isAdmin('assist')" class="col-sm-8 col-xs-10">
							<input id="account" name="account" v-model="stu.account" type="text" class="form-control" @input="getLastYearData"/>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="idno" class="col-sm-4 col-xs-2 column-required">身分證字號</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.idno}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="idno" name="idno" v-validate="'required|idnoSex:sex'" @change="changeDataGetStuBase" v-model="stu.idno" type="text" class="form-control" maxlength="10"/>
							<span class="text-danger" v-show="errors.has('idno')">{{ errors.first('idno') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-3 form-group">
						<label for="ssym" class="col-sm-4 col-xs-2">學制</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{ssymList.some(ssym => ssym.commCode == stu.ssym) ?
							ssymList.filter(ssym => ssym.commCode == stu.ssym)[0].commValue :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="ssym" name="ssym" v-model="stu.ssym" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in ssymList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="dept" class="col-sm-4 col-xs-2">科系</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{deptList.some(dept => dept.commCode == stu.dept) ?
							deptList.filter(dept => dept.commCode == stu.dept)[0].commValue :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="dept" name="dept" v-model="stu.dept" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in deptList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="drade" class="col-sm-4 col-xs-2">年級</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{dradeList.some(drade => drade.key == stu.drade) ?
							dradeList.filter(drade => drade.key == stu.drade)[0].value :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="drade" name="drade" v-model="stu.drade" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in dradeList" :key="key" :value="item.key">{{ item.value }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="dradeClass" class="col-sm-4 col-xs-2">班級</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{dradeClassList.some(dradeClass => dradeClass.key == stu.dradeClass) ?
							dradeClassList.filter(dradeClass => dradeClass.key == stu.dradeClass)[0].value :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="dradeClass" name="dradeClass" v-model="stu.dradeClass" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in dradeClassList" :key="key" :value="item.key">{{ item.value }}
								</option>
							</select>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-3 form-group">
						<label for="state" class="col-sm-4 col-xs-2">在學狀態</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{uStateList.some(uState => uState.commCode == stu.state) ?
							uStateList.filter(uState => uState.commCode == stu.state)[0].commValue :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="state" name="state" v-model="stu.state" class="form-control" disabled>
                <option value="">請選擇</option>
								<option v-for="(item,key) in uStateList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="entryYear" class="col-sm-4 col-xs-2">入學年</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.entryYear}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="entryYear" name="entryYear" v-model="stu.entryYear" type="number" class="form-control" />
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="entryMonth" class="col-sm-4 col-xs-2">入學月</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.entryMonth}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="entryMonth" name="entryMonth" v-model="stu.entryMonth" type="number" class="form-control" />
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="phone" class="col-sm-4 col-xs-2">行動電話</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.phone}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="phone" name="phone" v-model="stu.phone" type="text" class="form-control" />
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-6 form-group">
						<label for="schMail" class="col-sm-2 col-xs-2">學校信箱</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.schMail}}</div>
						<div v-else class="col-sm-10 col-xs-10">
							<input id="schMail" name="schMail" v-model="stu.schMail" type="email" class="form-control" />
						</div>
					</div>
					<div class="col-md-6 form-group">
						<label for="extMail" class="col-sm-2 col-xs-2 column-required">個人信箱</label>
						<div v-if="!isEditable" class="col-sm-8 col-xs-10">{{stu.extMail}}</div>
						<div v-else class="col-sm-10 col-xs-10">
							<input id="extMail" name="extMail" v-validate="'required'" v-model="stu.extMail" type="email" class="form-control" />
							<span class="text-danger" v-show="errors.has('extMail')">{{ errors.first('extMail') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12 form-group" v-if="isInfo">
						<label class="col-xs-3">地址</label>
						<div class="col-xs-9 col-md-10">
							{{ stu.resiFullAddress }}
						</div>
					</div>
					<div class="col-md-12 form-group" v-else>
						<label class="col-xs-2 col-md-1 form-group">地址</label>
						<div class="col-xs-3 col-md-2 form-group">
							<select v-model="stu.resiCityId" name="resiCityId"  class="form-control" @change="getResiArea()">
								<option disabled value="">請選擇</option>
								<option v-for="(item,key) in cityList" :key="key" :value="item.cityId">{{ item.cityName }}
								</option>
							</select>
						</div>
						<div class="col-xs-3 col-md-2 form-group">
							<select v-model="stu.resiAreaId" name="resiAreaId"  class="form-control">
								<option disabled value="">請選擇</option>
								<option v-for="(item,key) in areaList" :key="key" :value="item.areaId">{{ item.areaName }}
								</option>
							</select>
						</div>
						<div class="col-xs-offset-util-3 col-xs-9 col-md-7 form-group">
							<input type="text" id="resiAddr" name="resiAddr" class="form-control" v-model="stu.resiAddr" placeholder="地址" maxlength="100"/>
						</div>
					</div>
				</div>
				<div class="row form-group col-md-12">
					<table class="table table-no-more table-bordered table-striped mb-none">
						<thead>
							<tr>
								<th class="text-center" style="width: 3%">序號</th>
								<th class="text-center" style="width: 25%;">學生關係人</th>
								<th class="text-center" style="width: 20%;">姓名</th>
								<th class="text-center" style="width: 20%;">身分證字號</th>
								<th class="text-center" style="width: 20%;">職業</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(kinship, index) in reliefApply.kinshipList" :key="index">
								<td data-title="序號" class="text-center" style="vertical-align: middle;" :class="index == 0 || index == 1 || anyKinshipHasValue(kinship) ? 'column-required' : ''">{{index + 1}}</td>
								<td data-title="學生關係人" class="text-center">
                  <div :class="isKinshipDeletable(kinship) ? 'col-xs-1' : ''" :style="isKinshipDeletable(kinship) ? '' : 'display:none'">
                    <a @click="clearKinship(index)"><i class="fa fa-trash" style="font-size: 2rem;padding-top: 5px;"></i></a>
                  </div>
                  <div :class="isKinshipDeletable(kinship) ? 'col-xs-6' : 'col-xs-7'">
										<select :id="'kinshipType_'+index" :name="'kinshipType_'+index" :ref="'kinshipType_'+index" v-model="kinship.kinshipType" v-validate="index == 0 || index == 1 || anyKinshipHasValue(kinship) ? 'required' : ''" class="form-control" :disabled="!isEditable">
											<option value="">請選擇</option>
											<option v-for="(item,key) in reliefKinshipList" :key="key" :value="item.commCode">{{ item.commValue }}
											</option>
										</select>
										<span class="text-danger" v-show="errors.has(`kinshipType_${index}`)">{{ errors.first(`kinshipType_${index}`) }}</span>
									</div>
									<div class="col-xs-5">
										<select :id="'status_'+index" :name="'status_'+index" v-model="kinship.status"  v-validate="index == 0 || index == 1 || anyKinshipHasValue(kinship) ? 'required' : ''" class="form-control" :disabled="!isEditable"
										@change="() => {if(kinship.status != 'O'){kinship.statusValue = '';}}">
											<option value="">請選擇</option>
											<option v-for="(item,key) in reliefKinshipStateList" :key="key" :value="item.commCode">{{ item.commValue }}
											</option>
										</select>
										<span class="text-danger" v-show="errors.has(`status_${index}`)">{{ errors.first(`status_${index}`) }}</span>
									</div>
								</td>
								<td data-title="姓名" style="vertical-align: middle;">
									<input :id="'name_'+index" :name="'name_'+index" v-validate="((index == 0 || index == 1 || anyKinshipHasValue(kinship))) && (kinship.status != 'P' && kinship.status != 'O') ? 'required' : ''" v-model="kinship.name" type="text" class="form-control" :disabled="!isEditable" maxlength="20">
									<span class="text-danger" v-show="errors.has(`name_${index}`)">{{ errors.first(`name_${index}`) }}</span>
								</td>
								<td data-title="身分證字號" style="vertical-align: middle;">
									<input :id="'idNo_'+index" :name="'idNo_'+index" v-validate="((index == 0 || index == 1 || anyKinshipHasValue(kinship)))  && (kinship.status != 'P' && kinship.status != 'O' && kinship.status != 'D') ? `required|kinIdnoSex:kinshipType_${index}` : ''" v-model="kinship.idNo" type="text" class="form-control" :disabled="!isEditable" maxlength="10"
									@input="(e) => {kinship.idNo = e.target.value.toUpperCase()}">
									<span class="text-danger" v-show="errors.has(`idNo_${index}`)">{{ errors.first(`idNo_${index}`) }}</span>
								</td>
								<td data-title="職業" class="text-center">
									<div class="col-xs-6">
										<select :id="'occupationType_'+index" :name="'occupationType_'+index" v-validate="((index == 0 || index == 1 || anyKinshipHasValue(kinship))) && (kinship.status != 'P' && kinship.status != 'O') ? 'required' : ''" v-model="kinship.occupationType" class="form-control" :disabled="!isEditable"
										@change="() => {if(kinship.occupationType != 'O'){kinship.occupationValue = '';}}">
											<option value="">請選擇</option>
											<option v-for="(item,key) in reliefKinshipOccupationList" :key="key" :value="item.commCode">{{ item.commValue }}
											</option>
										</select>
										<span class="text-danger" v-show="errors.has(`occupationType_${index}`)">{{ errors.first(`occupationType_${index}`) }}</span>
									</div>
									<div class="col-xs-6">
										<input :id="'occupationValue_'+index" :name="'occupationValue_'+index" v-model="kinship.occupationValue" :disabled="!(kinship.occupationType == 'O' && isEditable)"
										v-validate="kinship.occupationType == 'O'? 'required' : ''" type="text" class="form-control" maxlength="10">
										<span class="text-danger" v-show="errors.has(`occupationValue_${index}`)">{{ errors.first(`occupationValue_${index}`) }}</span>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label for="reliefType" class="col-sm-4 col-xs-2 column-required">優待類別</label>
						<div class="col-sm-8 col-xs-10">
							<select id="reliefType" name="reliefType" v-validate="'required'" v-model="reliefApply.reliefType" class="form-control" :disabled="!isEditable" @change="calcFeeInfo()">
								<option value="">請選擇</option>
								<option v-for="(item,key) in reliefTypeList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
							<span class="text-danger" v-show="errors.has('reliefType')">{{ errors.first('reliefType') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="reliefApply.reliefType === 'A2' || reliefApply.reliefType === 'A3' || reliefApply.reliefType === 'A4'">
					<div class="col-md-4 form-group">
						<label for="deceasedName" class="col-sm-4 col-xs-2 column-required">已故人姓名</label>
						<div class="col-sm-8 col-xs-10">
							<input id="deceasedName" name="deceasedName" v-validate="'required'" v-model="reliefApply.deceasedName" type="text" class="form-control" :disabled="!isEditable" maxlength="20"/>
							<span class="text-danger" v-show="errors.has('deceasedName')">{{ errors.first('deceasedName') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label for="deceasedKinship" class="col-sm-4 col-xs-2 column-required">已故人關係</label>
						<div class="col-sm-8 col-xs-10">
							<input id="deceasedKinship" name="deceasedKinship" v-validate="'required'" v-model="reliefApply.deceasedKinship" type="text" class="form-control" :disabled="!isEditable" maxlength="5"/>
							<span class="text-danger" v-show="errors.has('deceasedKinship')">{{ errors.first('deceasedKinship') }}</span>
						</div>
					</div>
					<div class="col-md-4 form-group">
						<label for="deceasedReason" class="col-sm-4 col-xs-2 column-required">死亡原因</label>
						<div class="col-sm-8 col-xs-10">
							<select id="deceasedReason" name="deceasedReason" v-validate="'required'" v-model="reliefApply.deceasedReason" class="form-control" :disabled="!isEditable">
								<option value="">請選擇</option>
								<option v-for="(item,key) in deceasedReasonList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
							<span class="text-danger" v-show="errors.has('deceasedReason')">{{ errors.first('deceasedReason') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="reliefApply.reliefType === 'A2' || reliefApply.reliefType === 'A3' || reliefApply.reliefType === 'A4'">
					<div class="col-md-6 form-group">
						<label class="col-sm-2 col-xs-2 column-required">撫卹期限</label>
						<div class="col-sm-8 col-xs-10 form-inline">
							<label for="pensionType_L">
								<input id="pensionType_L" name="pensionType_L" value="L" v-validate="'required'" v-model="reliefApply.pensionType" type="radio" class="radio-custom" :disabled="!isEditable"/>
								<span>卹期年限</span>
							</label>
							<label for="pensionValue">
								<input id="pensionValue" name="pensionValue" v-model="reliefApply.pensionValue" v-validate="reliefApply.pensionType == 'L' ? 'required|min_value:0' : ''" :disabled="reliefApply.pensionType != 'L' || !isEditable" type="number" style="width: 70px;" class="form-control"/>
								<span>年</span>
							</label>
							<label for="pensionType_F">
								<input id="pensionType_F" name="pensionType_F" value="F" v-validate="'required'" v-model="reliefApply.pensionType" type="radio" class="radio-custom" :disabled="!isEditable"/>
								<span>終身</span>
							</label>
							<label for="pensionType_O">
								<input id="pensionType_O" name="pensionType_O" value="O" v-validate="'required'" v-model="reliefApply.pensionType" type="radio" class="radio-custom" :disabled="!isEditable"/>
								<span>一次撫卹</span>
							</label>
							<span class="text-danger" v-show="errors.has('pensionType_L')">{{ errors.first('pensionType_L') }}</span>
							<span class="text-danger" v-show="errors.has('pensionValue')">年限為必填選項，不得為負數</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="reliefApply.pensionType === 'L' && (reliefApply.reliefType === 'A2' || reliefApply.reliefType === 'A3' || reliefApply.reliefType === 'A4')">
					<div class="col-md-6 form-group">
						<label for="pensionStartYear" class="col-sm-2 col-xs-2 column-required">起始撫卹期限</label>
						<div class="col-sm-8 col-xs-10 form-inline">
							<input id="pensionStartYear" name="pensionStartYear" v-validate="'required'" v-model="reliefApply.pensionStartYear" type="number" style="width: 90px;" class="form-control" :disabled="!isEditable"/>
							<span>年</span>
							<input id="pensionStartMonth" name="pensionStartMonth" v-validate="'required'" v-model="reliefApply.pensionStartMonth" type="number" style="width: 70px;" class="form-control" :disabled="!isEditable"/>
							<span>月</span>
							<span class="text-danger" v-show="errors.has('pensionStartYear') || errors.has('pensionStartMonth')">必填選項</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="reliefApply.pensionType === 'L' && (reliefApply.reliefType === 'A2' || reliefApply.reliefType === 'A3' || reliefApply.reliefType === 'A4')">
					<div class="col-md-6 form-group">
						<label for="pensionExtendYear" class="col-sm-2 col-xs-2">延長撫卹期限</label>
						<div class="col-sm-8 col-xs-10 form-inline">
							<input id="pensionExtendYear" name="pensionExtendYear" v-model="reliefApply.pensionExtendYear" type="number" style="width: 90px;" class="form-control" :disabled="!isEditable"/>
							<span>年</span>
							<input id="pensionExtendMonth" name="pensionExtendMonth" v-model="reliefApply.pensionExtendMonth" type="number" style="width: 70px;" class="form-control" :disabled="!isEditable"/>
							<span>月</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="reliefApply.reliefType === 'A1'">
					<div class="col-md-4 form-group">
						<label for="clanType" class="col-sm-4 col-xs-2 column-required">族別</label>
						<div class="col-sm-8 col-xs-10">
							<select id="clanType" name="clanType" v-validate="'required'" v-model="reliefApply.clanType" class="form-control" :disabled="!isEditable">
								<option value="">請選擇</option>
								<option v-for="(item,key) in clanList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
							<span class="text-danger" v-show="errors.has('clanType')">{{ errors.first('clanType') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="reliefApply.reliefType !== '' && reliefApply.reliefType !== 'A1'">
					<div class="col-md-9 form-group">
						<label for="proveFile" class="col-sm-4 col-xs-2 column-required">上傳佐證資料<br/>{{getProveFileDescription()}}</label>
						<div v-if="proveFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{reliefApply.proveFile}}
                <a v-if="isEditable" type="button" @click="() => {proveFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
							<a v-if="IsPdf(reliefApply.proveFile)" :href="getPreviewUrl(reliefApply.proveFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
							<div v-else-if="IsValidPreviewExt(reliefApply.proveFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
								<a :href="getPreviewUrl(reliefApply.proveFile)" target="_blank">
									<img class="img-fluid" :src="getPreviewUrl(reliefApply.proveFile)" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input type="file" id="proveFile" name="proveFile" accept=".pdf,image/*"  @change="getProveFile($event)" v-validate="'required'" />
							<span class="text-danger" v-show="errors.has('proveFile')">{{ errors.first('proveFile') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="reliefApply.reliefType !== '' && reliefApply.reliefType !== 'AD' && reliefApply.reliefType !== 'AF'">
					<div class="col-md-9 form-group">
						<label for="householdFile" class="col-sm-4 col-xs-2 column-required">
							3個月內戶籍謄本或新式戶口名簿上傳(皆含詳細記事)<br/>
							<a href="javascript:;" class="btn-link" @mouseover="display()" @mouseout="disappear()">上傳範例</a>
							<div id="box" class="box" style="z-index:1000;"><h4 class="blue">新式戶口名簿樣本</h4><img src="../../../../assets/images/1595926019829.jpg" width="500px"></div>
						</label>
						<div v-if="householdFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{reliefApply.householdFile}}
                <a v-if="isEditable" type="button" @click="() => {householdFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
							<a v-if="IsPdf(reliefApply.householdFile)" :href="getPreviewUrl(reliefApply.householdFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
							<div v-else-if="IsValidPreviewExt(reliefApply.householdFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
								<a :href="getPreviewUrl(reliefApply.householdFile)" target="_blank">
									<img class="img-fluid" :src="getPreviewUrl(reliefApply.householdFile)" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input type="file" id="householdFile" name="householdFile" accept=".pdf,image/*" @change="getHouseholdFile($event)" v-validate="'required'" />
							<span class="text-danger" v-show="errors.has('householdFile')">{{ errors.first('householdFile') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="!isShowPrintBtn">
					<div class="col-md-9 form-group">
						<label for="affidavitFile" class="col-sm-4 col-xs-2 column-required">
							上傳申請書暨切結書<br/>
						</label>
						<div v-if="affidavitFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{reliefApply.affidavitFile}}
                <a v-if="(!reliefApply.schReviewState || reliefApply.schReviewState == '0' || ((reliefApply.schReviewState == '4' || reliefApply.schReviewState == '5') && !isAdmin('assist')) ||
							 ((reliefApply.schReviewState == '1' || reliefApply.schReviewState == '6') && isAdmin('assist')))" type="button" @click="() => {affidavitFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
							<a v-if="IsPdf(reliefApply.affidavitFile)" :href="getPreviewUrl(reliefApply.affidavitFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
							<div v-else-if="IsValidPreviewExt(reliefApply.affidavitFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
								<a :href="getPreviewUrl(reliefApply.affidavitFile)" target="_blank">
									<img class="img-fluid" :src="getPreviewUrl(reliefApply.affidavitFile)" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input type="file" id="affidavitFile" name="affidavitFile" accept=".pdf,image/*" @change="getAffidavitFile($event)" v-validate="'required'" />
							<span class="text-danger" v-show="errors.has('affidavitFile')">{{ errors.first('affidavitFile') }}</span>
						</div>
					</div>
				</div>
        <div v-if="isAdmin('assist') && reliefApply.schReviewState != '0' && !!reliefApply.schReviewState" class="row form-group">
          <div class="col-sm-12">
            <label>隱私權及個人資料保護政策宣告：{{ (customFormatter(reliefApply.crDate, "YYYY")-1911) + customFormatter(reliefApply.crDate, "年MM月DD日") }} 第{{ !!reliefApply.privacyTreatyVersion ? reliefApply.privacyTreatyVersion : "1.0" }}版</label>
          </div>
        </div>
				<div class="row form-group" v-if="reliefApply.schReviewState != '0' && !!reliefApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">學校初審</h4>
					</div>
				</div>
        <div class="row form-group" v-if="isAdmin('assist') && reliefApply.schReviewState != '0' && !!reliefApply.schReviewState">
          <div class="col-md-9 form-group">
            <label for="discardIncomeFile" class="col-sm-4 col-xs-2">
              不列計所得切結書
            </label>
            <div v-if="discardIncomeFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{reliefApply.discardIncomeFile}}
                <a v-if="isEditable" type="button" @click="() => {discardIncomeFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
              <a v-if="IsPdf(reliefApply.discardIncomeFile)" :href="getPreviewUrl(reliefApply.discardIncomeFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
              <div v-else-if="IsValidPreviewExt(reliefApply.discardIncomeFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
                <a :href="getPreviewUrl(reliefApply.discardIncomeFile)" target="_blank">
                  <img class="img-fluid" :src="getPreviewUrl(reliefApply.discardIncomeFile)" alt="" style="width:200px; "/>
                </a>
              </div>
            </div>
            <div v-else class="col-sm-8 col-xs-10">
              <input type="file" id="discardIncomeFile" name="discardIncomeFile" accept=".pdf,image/*" @change="getDiscardIncomeFile($event)" />
              <span class="text-danger" v-show="errors.has('discardIncomeFile')">{{ errors.first('discardIncomeFile') }}</span>
            </div>
          </div>
        </div>
        <div class="row form-group" v-if="reliefApply.schReviewState != '0' && !!reliefApply.schReviewState">
					<div class="col-sm-3">
						<select id="schReviewState" name="schReviewState" v-validate="'required'" v-model="reliefApply.schReviewState" class="form-control" :disabled="!isAdmin('assist')">
							<option v-for="(item,key) in schreviewStateList" :key="key" :value="item.commCode">{{ item.commValue }}
							</option>
						</select>
						<span v-if="(reliefApply.schReviewState == '4' || reliefApply.schReviewState == '5') && !isAdmin('assist')">若需調整切結書以外的資訊，請點擊下方「編輯資料」。</span>
					</div>
				</div>
				<div v-if="reliefApply.schReviewState == '3' || reliefApply.schReviewState == '4' || reliefApply.schReviewState == '5'" class="row form-group">
					<div class="col-sm-12">
						<label for="schReviewContent">{{schreviewStateList.filter(state => state.commCode == reliefApply.schReviewState)[0].commValue}}說明</label>
						<textarea id="schReviewContent" name="schReviewContent" v-model="reliefApply.schReviewContent" rows="3" class="form-control" :disabled="!isAdmin('assist')">
						</textarea>
					</div>
					<hr/>
				</div>
				<div v-if="isAdmin('assist') && reliefApply.schReviewState != '0' && !!reliefApply.schReviewState">
					<div class="row form-group">
						<div class="col-sm-12">
							<h4 style="font-weight: bold;">課程加退選金額</h4>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-sm-6 form-group">
							<label for="dropHour" class="col-sm-2 col-xs-1">退選時數</label>
							<div class="col-sm-3 col-xs-2">
								<input id="dropHour" name="dropHour" v-model="reliefApply.dropHour" type="number" class="form-control" @input="calcFeeInfo()"/>
							</div>
							<span >原應收學費- (1030x時數)，原應收雜費-(400x時數)</span>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-sm-6 form-group">
							<label for="addHour" class="col-sm-2 col-xs-1">加選時數</label>
							<div class="col-sm-3 col-xs-2">
								<input id="addHour" name="addHour" v-model="reliefApply.addHour" type="number" class="form-control"  @input="calcFeeInfo()"/>
							</div>
							<span >原應收學費+(1030x時數)，原應收雜費+(400x時數)</span>
						</div>
					</div>
					<hr/>
					<div class="row form-group">
						<div class="col-sm-12">
							<h4 style="font-weight: bold;">休、退學減免金額</h4>
						</div>
					</div>
					<div class="row form-group">
						<label for="quitType_No" class="col-md-12">
							<input id="quitType_No" name="quitType_No" value="" v-model="reliefApply.quitType" type="radio" @change="calcFeeInfo()"/>
							<span>無</span>
						</label>
						<label v-for="(item, index) in quitList" :for="`quitType_${item.commCode}`" :key="index" class="col-md-12">
							<input :id="`quitType_${item.commCode}`" :name="`quitType_${item.commCode}`" :value="item.commCode" v-model="reliefApply.quitType" type="radio" @change="calcFeeInfo()"/>
							<span>{{item.commValue}}</span>
						</label>
					</div>
					<hr/>
					<div class="row form-group">
						<div class="col-sm-12">
							<h4 style="font-weight: bold;">費用資訊{{!!feeInfoError ? `(${feeInfoError})` : ''}}</h4>
              <a v-if="feeInfoError == ''" class="btn-link" style="cursor: pointer;" @click="calcFeeInfo()">重新計算費用資訊</a>
							<a v-if="feeInfoError == '沒有該學生申請學期的費用資料' || feeInfoError == ''" class="btn-link" style="cursor: pointer;" @click="syncSchoolFee()">同步學雜費資料</a>
							<a v-if="feeInfoError == '沒有該申請類型或學生系別的費用設定'" class="btn-link" style="cursor: pointer;" @click="gotoView('relief.fee')">前往費用設定</a>
						</div>
					</div>
					<div class="row form-group col-md-12" style="float: inherit;">
						<table class="table table-no-more table-bordered table-striped mb-none">
							<thead>
								<tr>
									<th class="text-center" style="width: 13%;" rowspan="2"></th>
									<th class="text-center" style="width: 9%;" colspan="3" >正常</th>
									<th class="text-center" style="width: 9%;" colspan="3" >課程 加退選（僅進修部使用）</th>
									<th class="text-center" style="width: 9%;" colspan="3" >休、退學</th>
								</tr>
								<tr>
									<th class="text-center" style="width: 9%;" >A應收</th>
									<th class="text-center" style="width: 9%;" >B減免</th>
									<th class="text-center" style="width: 9%;" >C應繳</th>
									<th class="text-center" style="width: 9%;" >D應收</th>
									<th class="text-center" style="width: 9%;" >E減免</th>
									<th class="text-center" style="width: 9%;" >F應繳</th>
									<th class="text-center" style="width: 9%;" >G應收</th>
									<th class="text-center" style="width: 9%;" >H減免</th>
									<th class="text-center" style="width: 9%;" >I應繳</th>
								</tr>
							</thead>
              <tbody>
                <tr>
                  <td>1學費：</td>
                  <td data-title="正常應收" class="text-center">
                    {{!reliefApply.feeInfo.tuiCreditFee ? "" : reliefApply.feeInfo.tuiCreditFee}}
                  </td>
                  <td data-title="正常減免" class="text-center">
                    {{!reliefApply.feeInfo.tuiCreditFee || reliefApply.schReviewState === "1" ? "" : reliefApply.feeInfo.tuiCreditFeeDiscount}}
                  </td>
                  <td data-title="正常應繳" class="text-center">
                    {{!reliefApply.feeInfo.tuiCreditFee || reliefApply.schReviewState === "1"  ? "" : reliefApply.feeInfo.tuiCreditFee - reliefApply.feeInfo.tuiCreditFeeDiscount || 0}}
                  </td>
                  <td data-title="加退選應收" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.nightTuiCreditFee}}
                  </td>
                  <td data-title="加退選減免" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.nightTuiCreditFeeDiscount}}
                  </td>
                  <td data-title="加退選應繳" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.nightTuiCreditFee - reliefApply.feeInfo.nightTuiCreditFeeDiscount}}
                  </td>
                  <td data-title="休退選應收" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.quitTuiCreditFee}}
                  </td>
                  <td data-title="休退選減免" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.quitTuiCreditFeeDiscount}}
                  </td>
                  <td data-title="休退選應繳" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.quitTuiCreditFee - reliefApply.feeInfo.quitTuiCreditFeeDiscount}}
                  </td>
                </tr>
                <!---------------------------------------->
                <tr>
                  <td>2雜費：</td>
                  <td data-title="正常應收" class="text-center">
                    {{!reliefApply.feeInfo.tuiMisceFee ? "" : reliefApply.feeInfo.tuiMisceFee}}
                  </td>
                  <td data-title="正常減免" class="text-center">
                    {{!reliefApply.feeInfo.tuiMisceFee || reliefApply.schReviewState === "1" ? "" : reliefApply.feeInfo.tuiMisceFeeDiscount}}
                  </td>
                  <td data-title="正常應繳" class="text-center">
                    {{!reliefApply.feeInfo.tuiMisceFee || reliefApply.schReviewState === "1" ? "" : reliefApply.feeInfo.tuiMisceFee - reliefApply.feeInfo.tuiMisceFeeDiscount || 0}}
                  </td>
                  <td data-title="加退選應收" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiMisceFee ? "" : reliefApply.feeInfo.nightTuiMisceFee}}
                  </td>
                  <td data-title="加退選減免" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiMisceFee ? "" : reliefApply.feeInfo.nightTuiMisceFeeDiscount}}
                  </td>
                  <td data-title="加退選應繳" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiMisceFee ? "" : reliefApply.feeInfo.nightTuiMisceFee - reliefApply.feeInfo.nightTuiMisceFeeDiscount}}
                  </td>
                  <td data-title="休退選應收" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.quitTuiMisceFee}}
                  </td>
                  <td data-title="休退選減免" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.quitTuiMisceFeeDiscount}}
                  </td>
                  <td data-title="休退選應繳" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.quitTuiMisceFee - reliefApply.feeInfo.quitTuiMisceFeeDiscount}}
                  </td>
                </tr>
                <!---------------------------------------->
                <tr>
                  <td>3保險費：</td>
                  <td data-title="正常應收" class="text-center">
                    {{!reliefApply.feeInfo.tuiBenefits ? "" : reliefApply.feeInfo.tuiBenefits}}
                  </td>
                  <td data-title="正常減免" class="text-center">
                    {{!reliefApply.feeInfo.tuiBenefits || reliefApply.schReviewState === "1" ? "" : reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="正常應繳" class="text-center">
                    {{!reliefApply.feeInfo.tuiBenefits || reliefApply.schReviewState === "1" ? "" : reliefApply.feeInfo.tuiBenefits - reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="加退選應收" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.tuiBenefits}}
                  </td>
                  <td data-title="加退選減免" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="加退選應繳" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.tuiBenefits - reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="休退選應收" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.tuiBenefits}}
                  </td>
                  <td data-title="休退選減免" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="休退選應繳" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.tuiBenefits - reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                </tr>
                <!---------------------------------------->
                <tr>
                  <td>4電腦使用費：</td>
                  <td data-title="正常應收" class="text-center">
                    {{!reliefApply.feeInfo.tuiComputerFee ? "" : reliefApply.feeInfo.tuiComputerFee}}
                  </td>
                  <td data-title="正常減免" class="text-center">
                    {{!reliefApply.feeInfo.tuiComputerFee || reliefApply.schReviewState === "1" ? "" : 0}}
                  </td>
                  <td data-title="正常應繳" class="text-center">
                    {{!reliefApply.feeInfo.tuiComputerFee || reliefApply.schReviewState === "1" ? "" : reliefApply.feeInfo.tuiComputerFee}}
                  </td>
                  <td data-title="加退選應收" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.tuiComputerFee}}
                  </td>
                  <td data-title="加退選減免" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : 0}}
                  </td>
                  <td data-title="加退選應繳" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.tuiComputerFee}}
                  </td>
                  <td data-title="休退選應收" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.tuiComputerFee}}
                  </td>
                  <td data-title="休退選減免" class="text-center">
                    {{!reliefApply.quitType ? "" : 0}}
                  </td>
                  <td data-title="休退選應繳" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.tuiComputerFee}}
                  </td>
                </tr>
                <!---------------------------------------->
                <tr>
                  <td>合計</td>
                  <td data-title="正常應收" class="text-center">
                    {{!reliefApply.feeInfo.tuiCreditFee ? "" : reliefApply.feeInfo.tuiCreditFee + reliefApply.feeInfo.tuiMisceFee + reliefApply.feeInfo.tuiBenefits + reliefApply.feeInfo.tuiComputerFee}}
                  </td>
                  <td data-title="正常減免" class="text-center">
                    {{!reliefApply.feeInfo.tuiCreditFee || reliefApply.schReviewState === "1" ? "" : reliefApply.feeInfo.tuiCreditFeeDiscount + reliefApply.feeInfo.tuiMisceFeeDiscount + reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="正常應繳" class="text-center">
                    {{!reliefApply.feeInfo.tuiCreditFee || reliefApply.schReviewState === "1" ? "" : reliefApply.feeInfo.tuiCreditFee + reliefApply.feeInfo.tuiMisceFee + reliefApply.feeInfo.tuiBenefits + reliefApply.feeInfo.tuiComputerFee - reliefApply.feeInfo.tuiCreditFeeDiscount - reliefApply.feeInfo.tuiMisceFeeDiscount - reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="加退選應收" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.nightTuiCreditFee + reliefApply.feeInfo.nightTuiMisceFee + reliefApply.feeInfo.tuiBenefits + reliefApply.feeInfo.tuiComputerFee}}
                  </td>
                  <td data-title="加退選減免" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.nightTuiCreditFeeDiscount + reliefApply.feeInfo.nightTuiMisceFeeDiscount + reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="加退選應繳" class="text-center">
                    {{!reliefApply.feeInfo.nightTuiCreditFee ? "" : reliefApply.feeInfo.nightTuiCreditFee + reliefApply.feeInfo.nightTuiMisceFee + reliefApply.feeInfo.tuiBenefits + reliefApply.feeInfo.tuiComputerFee - reliefApply.feeInfo.nightTuiCreditFeeDiscount - reliefApply.feeInfo.nightTuiMisceFeeDiscount - reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="休退選應收" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.quitTuiCreditFee + reliefApply.feeInfo.quitTuiMisceFee + reliefApply.feeInfo.tuiBenefits + reliefApply.feeInfo.tuiComputerFee}}
                  </td>
                  <td data-title="休退選減免" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.quitTuiCreditFeeDiscount + reliefApply.feeInfo.quitTuiMisceFeeDiscount + reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                  <td data-title="休退選應繳" class="text-center">
                    {{!reliefApply.quitType ? "" : reliefApply.feeInfo.quitTuiCreditFee + reliefApply.feeInfo.quitTuiMisceFee + reliefApply.feeInfo.tuiBenefits + reliefApply.feeInfo.tuiComputerFee - reliefApply.feeInfo.quitTuiCreditFeeDiscount - reliefApply.feeInfo.quitTuiMisceFeeDiscount - reliefApply.feeInfo.tuiBenefitsDiscount}}
                  </td>
                </tr>
              </tbody>
						</table>
					</div>
					<div class="row form-group col-md-12" style="display: grid;float: inherit;">
						<div class="col-12" style="margin: 0px;display: flex;align-items: center;">
							<div class="col-lg-2">
								<div style="font-weight: bold;">補助費：</div>
							</div>
							<div class="col-lg-2 col-sm-12">
								書籍費 {{reliefApply.feeInfo.bookFee}}
							</div>
							<div class="col-lg-2 col-sm-12">
								制服費 {{reliefApply.feeInfo.uniformFee}}
							</div>
							<div class="col-lg-2 col-sm-12">
								生活費 {{reliefApply.feeInfo.livingFee}}
							</div>
						</div>
						<div class="col-12" style="margin: 10px 0 0 0;display: flex;align-items: center;">
							<div class="col-lg-2">
								<div style="font-weight: bold;">繳費資訊：</div>
							</div>
							<div class="col-lg-2">
								銀行金額 {{reliefApply.feeInfo.paymoney}}
							</div>
							<div class="col-lg-2">
								出納金額 {{reliefApply.feeInfo.paymoneyCash}}
							</div>
							<div class="col-lg-2">
								就學貸款 {{reliefApply.feeInfo.realloan}}
							</div>
							<div class="col-lg-2">
								繳費日期 {{reliefApply.feeInfo.paydate}}
							</div>
						</div>
					</div>
					<hr/>
				</div>
				<div class="row form-group" v-if="reliefApply.schReviewState != '0' && !!reliefApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">教育部審核</h4>
					</div>
				</div>
				<div class="row form-group" v-if="reliefApply.schReviewState != '0' && !!reliefApply.schReviewState">
					<div class="col-lg-12 form-group" v-if="reliefApply.reliefType === 'A9' ||reliefApply.reliefType === 'A8' ||reliefApply.reliefType === 'A7' ||reliefApply.reliefType === 'AA' ||reliefApply.reliefType === 'AB' ||reliefApply.reliefType === 'AC'">
						<div class="col-lg-3 col-md-6 col-xs-6" style="margin: 0px;">財稅中心：</div>
						<div class="col-lg-8 col-md-6 col-sx-6" style="" :style="reliefApply.moeReview == '不合格' ? {color: 'red',margin: '0px'} : {margin: '0px'}">{{reliefApply.moeReview}}</div>
					</div>
					<div class="col-lg-12 form-group">
						<div class="col-lg-3 col-md-6 col-xs-6" style="margin: 0px;">優先發放部別：</div>
						<div class="col-lg-8 col-md-6 col-sx-6" style="margin: 0px;">{{reliefApply.moeReviewMinistry}}</div>
					</div>
          <div class="col-lg-12 form-group">
            <div class="col-lg-3 col-md-6 col-xs-6" style="margin: 0px;">減免金額：</div>
            <div class="col-lg-8 col-md-6 col-sx-6" style="margin: 0px;">{{reliefApply.moeReliefAmount}}</div>
          </div>
					<div class="col-lg-12 form-group">
						<div class="col-lg-3 col-md-6 col-xs-6" style="margin: 0px;">重複申請狀況說明：</div>
						<div class="col-lg-8 col-md-6 col-sx-6" style="margin: 0px;">{{reliefApply.moeReviewDesc}}</div>
					</div>
          <div class="col-sm-12 form-group">
            <div class="col-sm-3">放棄</div>
            <div class="col-sm-3" style="display: flex;">
              <div class="checkbox-custom">
                <input id="abandon" name="abandon" type="checkbox" value="Y" v-model="reliefApply.abandon" :disabled="!isAdmin('assist')">
                <label for="abandon">是</label>
              </div>
            </div>
          </div>
          <div class="col-sm-12 " v-if="reliefApply.abandon">
            <label class="col-sm-3" for="abandonContent">放棄說明</label>
            <div class=" col-sm-6">
              <textarea id="abandonContent" name="abandonContent" v-model="reliefApply.abandonContent" rows="3" class="form-control" :disabled="!isAdmin('assist')">
              </textarea>
            </div>
          </div>
					<hr/>
				</div>
				<div class="row form-group" v-if="isAdmin('assist') && reliefApply.schReviewState != '0' && !!reliefApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">退費選項</h4>
					</div>
				</div>
				<div class="row form-group"  v-if="isAdmin('assist') && reliefApply.schReviewState != '0' && !!reliefApply.schReviewState">
					<div class="col-sm-12 form-group">
						<div class="col-sm-3">是否為需退費學生名單</div>
						<div class="col-sm-3" style="display: flex;">
							<div class="checkbox-custom">
								<input id="isRefund" name="isRefund" type="checkbox" value="Y" v-model="reliefApply.isRefund">
								<label for="isRefund">是</label>
							</div>
						</div>
					</div>
          <div class="col-sm-12">
            <div class="col-sm-3">只退補助金額</div>
            <div class="col-sm-3" style="display: flex;">
              <div class="checkbox-custom">
                <input id="onlyRefundRelief" name="onlyRefundRelief" type="checkbox" value="Y" v-model="reliefApply.onlyRefundRelief">
                <label for="onlyRefundRelief">是</label>
              </div>
            </div>
          </div>
				</div>
				<div class="text-center form-group" v-if="(!reliefApply.schReviewState || reliefApply.schReviewState == '0' || reliefApply.schReviewState == '4'|| reliefApply.schReviewState == '5') && isShowPrintBtn">
					<button class="btn" v-if="JSON.stringify(this.sessionData) != '{}'" @click="gotoView('relief.list')">返回</button>
					<button class="btn s_btn_o" @click="handleSave(true)">儲存</button>
					<button class="btn s_btn_o" @click="handleSave()">儲存並預覽列印</button>
				</div>
				<div class="text-center form-group" v-else>
					<button class="btn" v-if="JSON.stringify(this.sessionData) != '{}'" @click="gotoView('relief.list')">返回</button>
					<button class="btn s_btn_g" @click="showPrintPopup(true)" v-if="(!reliefApply.schReviewState || reliefApply.schReviewState == '0' || ((reliefApply.schReviewState == '4' || reliefApply.schReviewState == '5') && !isAdmin('assist')))">列印切結書</button>
					<button class="btn s_btn_g" @click="backToEdit()" v-if="(!reliefApply.schReviewState || reliefApply.schReviewState == '0' || ((reliefApply.schReviewState == '4' || reliefApply.schReviewState == '5') && !isAdmin('assist')))">編輯資料</button>
					<button class="btn s_btn_o" @click="handleSave()" v-if="!reliefApply.schReviewState || reliefApply.schReviewState == '0' || reliefApply.schReviewState == '4' || reliefApply.schReviewState == '5' || isAdmin('assist')">送出</button>
				</div>
            </div>
		</section>
		<printPopup v-if="isShowPrintPopup"/>
	</div>
</template>
<script>
import printPopup from "./printPopup";
import treaty from "@/components/assist/treaty";
export default {
	components:{
		printPopup,
    treaty
	},
	data(){
		return {
			stu: {
				idno: "",
				name: "",
				sex: "",
				account:"",
				ssym: "",
				dept: "",
				drade: "",
				dradeClass: "",
				state: "",
				entryYear: "",
				entryMonth: "",
				phone: "",
				schMail: "",
				extMail: "",
				resiAddr: "",
				resiCityId: "",
				resiAreaId: "",
				deptCode: "",
			},
			reliefApply:{
				id: "",
				kinshipList: [
					{
						kinshipType: "",
						status: "",
						occupationType: ""
					},
					{
						kinshipType: "",
						status: "",
						occupationType: ""
					},
					{
						kinshipType: "",
						status: "",
						occupationType: ""
					}
				],
				reliefType: "",
				affidavitFile: "",
				deceasedName: "",
				deceasedKinship: "",
				deceasedReason: "",
				pensionType: "",
				pensionValue: "",
				pensionStartYear: "",
				pensionStartMonth: "",
				pensionExtendYear: "",
				pensionExtendMonth: "",
				clanType: "",
				proveFile: "",
				householdFile: "",
        discardIncomeFile: "",
        schReviewState: "",
				schReviewContent: "",
				addHour: "",
				dropHour: "",
				quitType: "",
				moeReview: "",
				moeReviewMinistry: "",
				moeReviewDesc: "",
        moeReliefAmount: "",
				isRefund: "",
				payInfo: {},
				feeInfo: {},
        abandon: false,
        abandonContent: "",
        onlyRefundRelief: false,
        crDate: ""
			},
			// 下拉選單來源
			ssymList: [],
			deptList: [],
			cityList: [],
			areaList: [],
			reliefTypeList: [],
			reliefKinshipList: [],
			reliefKinshipStateList: [],
			reliefKinshipOccupationList: [],
			deceasedReasonList: [],
			clanList: [],
			quitList: [],
			schreviewStateList: [],
			uStateList: [],
			dradeList: [
				{
					key: "1",
					value: "一年級"
				},
				{
					key: "2",
					value: "二年級"
				},
				{
					key: "3",
					value: "三年級"
				},
				{
					key: "4",
					value: "四年級"
				},
				{
					key: "5",
					value: "五年級"
				},
				{
					key: "6",
					value: "六年級"
				},
				{
					key: "7",
					value: "七年級"
				},
				{
					key: "8",
					value: "八年級"
				},
				{
					key: "9",
					value: "九年級"
				}
			],
			dradeClassList: [
				{
					key: "A",
					value: "A班"
				},
				{
					key: "B",
					value: "B班"
				},
				{
					key: "C",
					value: "C班"
				},
        {
          key: "D",
          value: "D班"
        },
			],
			//檔案
			proveFile: "",
			householdFile: "",
			stuPhoto: "",
			affidavitFile: "",
      discardIncomeFile: "",
			proveFilePreview: "",
			householdFilePreview: "",
			affidavitFilePreview: "",
      discardIncomeFilePreview: "",

			// 判斷是否顯示列印按鈕
			isShowPrintBtn: false,

			// 判斷是否顯示列印畫面
			isShowPrintPopup: false,

			// 透過身分證字號查詢進入
			isFromIdnoSearch: false,

			// 顯示費用資料錯誤訊息
			feeInfoError: "",

      // 是否顯示條約
      isShowTreaty: false
		}

	},
	mounted(){
    if(this.$route.name == "relief.apply.new") {
      this.isShowTreaty = true;
    }
		this.pageInit();
	},
	methods:{
		pageInit(){
			let api = `/api/relief/editInit?isNew=${this.$route.name == "relief.apply.new"}`;
			this.$axios.get(api).then(res => {
				if (res.data.status == "success") {
					this.ssymList = res.data.data.selectList.ssym
					this.deptList = res.data.data.selectList.dept
					this.cityList = res.data.data.selectList.city
					this.reliefTypeList = res.data.data.selectList.reliefType
					this.reliefKinshipList = res.data.data.selectList.reliefKinship
					this.reliefKinshipStateList = res.data.data.selectList.reliefKinshipState
					this.reliefKinshipOccupationList = res.data.data.selectList.reliefKinshipOccupation
					this.deceasedReasonList = res.data.data.selectList.deceasedReason
					this.clanList = res.data.data.selectList.clan
					this.quitList = res.data.data.selectList.quit
					this.schreviewStateList = res.data.data.selectList.reviewState
					this.uStateList = res.data.data.selectList.uState

					if (this.getStore(this.$route.name) != null) {
						let storeData = JSON.parse(this.getStore(this.$route.name));
						if(storeData.reliefApplyId != ""){
							api = `/api/relief/${storeData.reliefApplyId}`;
							this.$axios.get(api).then(res => {
								this.stu = {
									...res.data.data.stu,
									ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
									dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
								};
								this.reliefApply = {
									...res.data.data.ra,
									quitType: res.data.data.ra.quitType == null ? "" : res.data.data.ra.quitType,
									feeInfo: res.data.data.ra.feeInfo == null ? {} : JSON.parse(res.data.data.ra.feeInfo)
								};

								// 補足三個關係人資料
								for(let i=0; i<3; i++){
									if(this.reliefApply.kinshipList.length <= i ){
										this.reliefApply.kinshipList[i] = {
											kinshipType: "",
											status: "",
											occupationType: ""
										}
									}
								}

								// 建立預覽連結
								this.proveFilePreview = this.getPreviewUrl(this.reliefApply.proveFile);
								this.householdFilePreview = this.getPreviewUrl(this.reliefApply.householdFile);
								this.affidavitFilePreview = this.getPreviewUrl(this.reliefApply.affidavitFile);
                this.discardIncomeFilePreview = this.getPreviewUrl(this.reliefApply.discardIncomeFile);

								// 計算費用資訊
								if(JSON.stringify(this.reliefApply.feeInfo) == '{}') {
									this.calcFeeInfo();
								}
							});
						}

						if(storeData.isFromIdnoSearch != "") {
							this.isFromIdnoSearch = storeData.isFromIdnoSearch
						}
					} else {
						this.isShowPrintBtn = true;
					}


					if (this.$route.name == "relief.apply.new" && this.sessionData.accountType == "STU"){
						this.stu = {
							...res.data.data.stu,
							ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
							dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
						};

						if(res.data.data.lastReliefApply.id != "") {
							this.reliefApply.reliefType = res.data.data.lastReliefApply.reliefType;
							this.reliefApply.deceasedName = res.data.data.lastReliefApply.deceasedName;
							this.reliefApply.deceasedKinship = res.data.data.lastReliefApply.deceasedKinship;
							this.reliefApply.deceasedReason = res.data.data.lastReliefApply.deceasedReason;
							this.reliefApply.pensionType = res.data.data.lastReliefApply.pensionType;
							this.reliefApply.pensionValue = res.data.data.lastReliefApply.pensionValue;
							this.reliefApply.pensionStartYear = res.data.data.lastReliefApply.pensionStartYear;
							this.reliefApply.pensionStartMonth = res.data.data.lastReliefApply.pensionStartMonth;
							this.reliefApply.pensionExtendYear = res.data.data.lastReliefApply.pensionExtendYear;
							this.reliefApply.pensionExtendMonth = res.data.data.lastReliefApply.pensionExtendMonth;
              this.reliefApply.discardIncomeFile = res.data.data.lastReliefApply.discardIncomeFile;
							this.reliefApply.clanType = res.data.data.lastReliefApply.clanType;
							this.reliefApply.kinshipList = res.data.data.lastReliefApply.kinshipList;

							// 補足三個關係人資料
							for(let i=0; i<3; i++){
								if(res.data.data.lastReliefApply.kinshipList.length <= i ){
									this.reliefApply.kinshipList[i] = {
										kinshipType: "",
										status: "",
										occupationType: ""
									}
								}
							}
						}
					}
				} else if(res.data.status == "error"){
					bootbox.alert(res.data.msg);
					this.$router.back();
				}
			});
		},
		handleSave(withoutPrint = false){
      var orgKinshipList = this.reliefApply.kinshipList;
      this.reliefApply.kinshipList = this.reliefApply.kinshipList.filter(kin => this.anyKinshipHasValue(kin));
			this.$validator.validateAll().then((result) => {
				if (result) {
					if(this.reliefApply.id === ""){
						this.handleCreate(withoutPrint)
					} else {
						this.handleUpdate(withoutPrint);
					}
				}
				else {
          // 還原關係人資料
          this.reliefApply.kinshipList = orgKinshipList;
					bootbox.alert("請確認必填欄位是否有填寫正確，並至少填寫兩名關係人完整資料");
				}
			});
		},
		handleCreate(withoutPrint) {
			const api = "/api/relief";
			let formData = new FormData();

			const _this = this;
			this.stu.deptCode = this.stu.ssym + this.stu.dept;
      if(!(this.stu.deptCode.length == 0 || this.stu.deptCode.length == 3)) {
        bootbox.alert("學制及科系請兩項都填寫或是都留空");
        return;
      }

			for(let key in this.stu) {
				if(this.stu[key]) {
					formData.append(`stu.${key}`, this.stu[key]);
				}
			}
			this.reliefApply.isRefund = this.reliefApply.isRefund ? 'Y'	: '';
			for(let key in this.reliefApply) {
				if(this.reliefApply[key]) {
					if(typeof(this.reliefApply[key]) === "object") {
						if(Array.isArray(this.reliefApply[key])) {
							for(let i = 0; i < this.reliefApply[key].length; i++) {
								for(let k in this.reliefApply[key][i]) {
									if(this.reliefApply[key][i][k]) {
										formData.append(`reliefApply.${key}[${i}].${k}`, this.reliefApply[key][i][k]);
									}
								}
							}
						} else {
							formData.append(`reliefApply.${key}`, JSON.stringify(this.reliefApply[key]));
						}
					} else {
						formData.append(`reliefApply.${key}`, this.reliefApply[key]);
					}
				}
			}

			formData.append("householdFile", this.householdFile)
			formData.append("proveFile", this.proveFile)
			this.$axios.post(api, formData).then(res => {
				if(res.data.status === "success") {
					this.reliefApply.id = res.data.data.id;
					this.reliefApply.smtr = res.data.data.smtr;
          this.reliefApply.crDate = res.data.data.crDate;
					if(withoutPrint) {
            			// 儲存未送出申請
						if(JSON.stringify(this.sessionData) != '{}') {
							bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印切結書後以拍照或掃描的方式上傳檔案至切結書欄位並送出，才算完成線上申請。");
							this.gotoView('relief.list');
						} else {
							bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印切結書後以拍照或掃描的方式上傳檔案至切結書欄位並送出，才算完成線上申請。<br/>若無法當下完成切結書上傳可透過「學雜費減免申請查詢」功能，完成最後上傳步驟。");
							this.gotoView('relief.list', {idNo: this.stu.idno});
						}
					} else {
						_this.showPrintPopup(true)
					}
				} else if(res.data.status === "error") {
					bootbox.alert(res.data.msg);
				}
			});
		},
		handleUpdate(withoutPrint) {
			if ((!this.reliefApply.schReviewState || this.reliefApply.schReviewState == '0' ||
				((this.reliefApply.schReviewState == '4' || this.reliefApply.schReviewState == '5') &&
				!this.isAdmin('assist'))) && !this.isShowPrintBtn) {
				this.submitApply();
			} else {
				const api = `/api/relief/${this.reliefApply.id}`;
				let formData = new FormData();

				this.stu.deptCode = this.stu.ssym + this.stu.dept;
        if(!(this.stu.deptCode.length == 0 || this.stu.deptCode.length == 3)) {
          bootbox.alert("學制及科系請兩項都填寫或是都留空");
          return;
        }
				for(let key in this.stu) {
					if(this.stu[key]) {
						formData.append(`stu.${key}`, this.stu[key]);
					}
				}

				this.reliefApply.isRefund = this.reliefApply.isRefund ? 'Y'	: '';
				for(let key in this.reliefApply) {
					if(this.reliefApply[key]) {
						if(typeof(this.reliefApply[key]) === "object") {
							if(Array.isArray(this.reliefApply[key])) {
								for(let i = 0; i < this.reliefApply[key].length; i++) {
									for(let k in this.reliefApply[key][i]) {
										if(this.reliefApply[key][i][k]) {
											formData.append(`reliefApply.${key}[${i}].${k}`, this.reliefApply[key][i][k]);
										}
									}
								}
							} else {
								formData.append(`reliefApply.${key}`, JSON.stringify(this.reliefApply[key]));
							}
						} else {
							formData.append(`reliefApply.${key}`, this.reliefApply[key]);
						}
					}
				}

				formData.append("householdFile", this.householdFile);
				formData.append("proveFile", this.proveFile);
        formData.append("affidavitFile", this.affidavitFile);
        formData.append("discardIncomeFile", this.discardIncomeFile);
				this.$axios.post(api, formData).then(res => {
					if(res.data.status === "success") {
						if ((!this.reliefApply.schReviewState || this.reliefApply.schReviewState == '0' || this.reliefApply.schReviewState == '4'|| this.reliefApply.schReviewState == '5') && this.isShowPrintBtn) {
							if(withoutPrint) {
								this.isShowPrintBtn = false;
								if(this.reliefApply.schReviewState == '4'|| this.reliefApply.schReviewState == '5'){
									// 補件
									bootbox.dialog({
										message: "儲存成功。<br/>請選擇是否沿用原本的切結書申請或是重新上傳？",
										buttons: {
											upload: {
												label: '重新上傳',
												callback: () => {
													this.$parent.isShowPrintBtn = false;
													this.affidavitFilePreview = null
												}
											},
											submit: {
												label: '送出申請',
												callback: () => {
													this.submitApply();
												}
											}
										}
									})
								} else {
									// 儲存未送出申請
									if(JSON.stringify(this.sessionData) != '{}') {
										bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印切結書後以拍照或掃描的方式上傳檔案至切結書欄位並送出，才算完成申請。");
										this.gotoView('relief.list');
									} else {
										bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印切結書後以拍照或掃描的方式上傳檔案至切結書欄位並送出，才算完成申請。<br/>若無法當下完成切結書上傳可透過「學雜費減免申請查詢」功能，完成最後上傳步驟。");
										this.gotoView('relief.list', {idNo: this.stu.idno});
									}
								}
							} else {
								this.showPrintPopup(true)
							}
						} else if(this.isAdmin('assist')) {
							this.gotoView('relief.list')
						}
					} else if(res.data.status === "error") {
						bootbox.alert(res.data.msg);
					}
				});
			}
		},
		submitApply() {
			const api = `/api/relief/${this.reliefApply.id}/affidavit`;
			let formData = new FormData();
			formData.append("affidavitFile", this.affidavitFile);
			this.$axios.post(api, formData).then(res => {
				if(res.data.status === "success") {
					if(JSON.stringify(this.sessionData) != '{}') {
						bootbox.alert("線上申請成功，可至學雜費減免申請列表，來查詢申請狀態。<br/><b>重要 : 請將紙本文件繳交生輔組審核，未繳交紙本者，視同未申請。</b>");
						this.gotoView('relief.list');
					} else {
						bootbox.alert("線上申請成功，可透過「學雜費減免申請查詢」功能，以身分證字號來查詢申請狀態。<br/><b style='color:red;'>重要 : 請將紙本文件繳交生輔組審核，未繳交紙本者，視同未申請。</b>");
						this.gotoView('relief.list', {idNo: this.stu.idno})
					}
				} else if(res.data.status === "error") {
					bootbox.alert(res.data.msg);
				}
			});
		},
		syncSchoolFee(){
			const api = `/api/relief/syncSchoolFee`;
			this.$axios.post(api).then(res => {
				if(res.data.status === "success") {
					bootbox.alert("同步完成");
					this.pageInit();
				} else if(res.data.status === "error") {
					bootbox.alert(res.data.msg);
				}
			});
		},
		getHouseholdFile(event) {
			this.householdFile = event.target.files[0];
			if(this.householdFile){
				if(this.checkFileExtension(this.householdFile.name, ["jpg","jpeg","png","pdf"])){
					this.reliefApply.householdFile = this.householdFile.name;
					if (/^image/.test(this.householdFile.type)){
						this.compresImage(this.householdFile).then(result => {
							this.householdFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.householdFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getProveFile(event) {
			this.proveFile = event.target.files[0];
			if(this.proveFile){
				if(this.checkFileExtension(this.proveFile.name, ["jpg","jpeg","png","pdf"])){
					this.reliefApply.proveFile = this.proveFile.name;
					if (/^image/.test(this.proveFile.type)){
						this.compresImage(this.proveFile).then(result => {
							this.proveFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.proveFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		getAffidavitFile(event) {
			this.affidavitFile = event.target.files[0];
			if(this.affidavitFile){
				if(this.checkFileExtension(this.affidavitFile.name, ["jpg","jpeg","png","pdf"])){
					this.reliefApply.affidavitFile = this.affidavitFile.name;
					if (/^image/.test(this.affidavitFile.type)){
						this.compresImage(this.affidavitFile).then(result => {
							this.affidavitFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.affidavitFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
    getDiscardIncomeFile(event) {
      this.discardIncomeFile = event.target.files[0];
      if(this.discardIncomeFile){
        if(this.checkFileExtension(this.discardIncomeFile.name, ["jpg","jpeg","png","pdf"])){
          this.reliefApply.discardIncomeFile = this.discardIncomeFile.name;
          if (/^image/.test(this.discardIncomeFile.type)){
            this.compresImage(this.discardIncomeFile).then(result => {
              this.discardIncomeFile = result;
            });
          }
        }else{
          bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
          this.discardIncomeFile = null;
        }
      }else{
        bootbox.alert("上傳失敗，請重新上傳。");
      }
    },
    getProveFileDescription() {
			switch(this.reliefApply.reliefType) {
				case "A2":
				case "A3":
				case "A4":
					return "撫卹令、年撫卹金證書、核定函（須有學生名字，查驗正本，繳交影本)"
				case "A5":
					return "家長在職服務相關證明或在營服役證明";
				case "A7":
				case "A8":
				case "A9":
				case "AA":
				case "AB":
				case "AC":
					return "身心障礙手冊或身心障礙學生鑑輔會證明文件（查驗正本，繳交影本）";
				case "AD":
					return "低收入戶證明文件（須有學生名字)";
				case "AF":
					return "中低收入戶證明文件（須有學生名字）";
				case "A6":
					return "特殊境遇家庭身分證明文件（須有學生名字)";
			}
			return "";
		},
		calcFeeInfo() {
			if(this.isAdmin('assist') && !(!this.reliefApply.schReviewState || this.reliefApply.schReviewState == '0')) {
				const api = "/api/relief/calc";
				const body = {
					...this.reliefApply,
					payInfo: '{}',
					feeInfo: '{}'
				}
				this.$axios.post(api, body).then(res => {
					if(res.data.status === "success") {
						this.reliefApply.feeInfo = res.data.data;
						this.feeInfoError = "";
					} else if(res.data.status === "error") {
						this.feeInfoError = res.data.msg;
					}
				});
			}
		},
		anyKinshipHasValue(kinship) {
			return !!kinship.kinshipType || !!kinship.status || !!kinship.occupationType || !!kinship.name || !!kinship.idNo;
		},
		showPrintPopup(isOpen) {
			this.isShowPrintPopup = isOpen
		},
		backToEdit() {
			this.isShowPrintBtn = true;
		},
		async getResiArea() {
			this.stu.resiAreaId = "";
			this.stu.resiRoadId = "";
			this.stu.resiAreaList = [];
			this.stu.resiRoadList = [];
			const api = "/api/Common/getArea/" + this.stu.resiCityId;
			let resp = await this.$axios.post(api);
			if(resp.data.status == "success"){
				this.areaList = resp.data.data.areaList;
			}
		},
		IsPdf(filePath) {
			if(filePath != null && filePath != ""){
				var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
				if(ext == "pdf"){
					return true;
				}else{
					return false;
				}
			}
			return false;
		},
		IsValidPreviewExt(filePath) {
			if(filePath != null && filePath != ""){
				var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
				if(ext == "jpg" || ext == "jpeg" || ext == "png" || ext == "pdf"){
					return true;
				}else{
					return false;
				}
			}
			return false;
		},
		getPreviewUrl(filePath) {
			let url = "";
			if(this.IsValidPreviewExt(filePath)) {
				url = "/upload/" + filePath;
			}
			return url;
		},
		display() {
			document.getElementById("box").style.display = "block";
		},
		disappear() {
			document.getElementById("box").style.display = "none";
		},
    getLastYearData() {
      if(this.isAdmin('assist') && this.stu.account.length == 9) {
        let api = `/api/relief/lastYearData?account=${this.stu.account}`;
        this.$axios.get(api).then(res => {
          if (res.data.status == "success") {
            if(res.data.data != null){
              this.stu = {
                ...res.data.data.stu,
                ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
                dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
              };

              if(res.data.data.lastReliefApply != null && res.data.data.lastReliefApply.id != "") {
                this.reliefApply.reliefType = res.data.data.lastReliefApply.reliefType;
                this.reliefApply.deceasedName = res.data.data.lastReliefApply.deceasedName;
                this.reliefApply.deceasedKinship = res.data.data.lastReliefApply.deceasedKinship;
                this.reliefApply.deceasedReason = res.data.data.lastReliefApply.deceasedReason;
                this.reliefApply.pensionType = res.data.data.lastReliefApply.pensionType;
                this.reliefApply.pensionValue = res.data.data.lastReliefApply.pensionValue;
                this.reliefApply.pensionStartYear = res.data.data.lastReliefApply.pensionStartYear;
                this.reliefApply.pensionStartMonth = res.data.data.lastReliefApply.pensionStartMonth;
                this.reliefApply.pensionExtendYear = res.data.data.lastReliefApply.pensionExtendYear;
                this.reliefApply.pensionExtendMonth = res.data.data.lastReliefApply.pensionExtendMonth;
                this.reliefApply.clanType = res.data.data.lastReliefApply.clanType;
                this.reliefApply.discardIncomeFile = res.data.data.lastReliefApply.discardIncomeFile;
                this.reliefApply.kinshipList = res.data.data.lastReliefApply.kinshipList;

                // 補足三個關係人資料
                for(let i=0; i<3; i++){
                  if(res.data.data.lastReliefApply.kinshipList.length <= i ){
                    this.reliefApply.kinshipList[i] = {
                      kinshipType: "",
                      status: "",
                      occupationType: ""
                    }
                  }
                }
              }
            }
          } else if(res.data.status == "error"){
            bootbox.alert(res.data.msg);
            this.$router.back();
          }
        });
      }
    },
    clearKinship(index) {
      this.reliefApply.kinshipList.splice(index, 1);
      this.reliefApply.kinshipList.push({
        kinshipType: "",
        status: "",
        occupationType: ""
      });
    },
    isKinshipDeletable(kinship){
      // 管理員在待審狀態可以編輯
      if(!this.isAdmin('assist') || !(this.reliefApply.schReviewState == "1" || this.reliefApply.schReviewState == "6")) {
        return false;
      }
      // 有兩個以上關係人
      if(this.reliefApply.kinshipList.filter(kin => this.anyKinshipHasValue(kin)).length === 1) {
        return false;
      }
      // 關係人狀態為「離」
      if(!!kinship && kinship.status !== 'D') {
        return false;
      }
      return true;
    },
    changeDataGetStuBase() {
      if (!this.isAdmin('assist') && this.stu.idno.length == 10) {
        const api = `/api/lifeworkstudyapply/studIsExists/${this.stu.idno}`;
        const _this = this;
        this.$axios.post(api).then(resp=>{
          if(resp.data.status != "success"){
            bootbox.alert(resp.data.msg, function(){
              _this.$router.replace({ name: "index" });
            });
          }
        });

      }
    },
  },
	computed: {
		isInfo(){
			return this.$route.name != "relief.apply.new" || this.sessionData.accountType == "STU";
		},
		isEditable(){
			// 管理員在待審狀態可以編輯
			// 申請人或透過身分證查詢在草稿或待補件狀態可以編輯
			return (this.isAdmin('assist') && (this.reliefApply.schReviewState == "1" || this.reliefApply.schReviewState == "6")) ||
			 (this.sessionData.account == this.reliefApply.account && (
				 this.reliefApply.schReviewState == "0" || this.reliefApply.schReviewState == "4"|| this.reliefApply.schReviewState == "5") && this.isShowPrintBtn) ||
			 (this.isFromIdnoSearch && (
				 this.reliefApply.schReviewState == "0" || this.reliefApply.schReviewState == "4"|| this.reliefApply.schReviewState == "5") && this.isShowPrintBtn) ||
			 (!this.reliefApply.schReviewState && this.isShowPrintBtn);
		}
	},
	watch:{
		"stu.idno": function (val) {
			if(val && val != this.stu.idno){
        this.stu.idno = val.toUpperCase();
        if(val.length == 10) {
          const api = `/api/relief/isStuExists/${val}`;
          var _this = this;
          this.$axios.post(api).then(resp => {
            if (resp.data.status == "success") {
            } else {
              bootbox.alert(resp.data.msg, function () {
                _this.$router.replace({name: "index"});
              });
            }
          });
        }
			}
		},
		"reliefApply.pensionType": function (val) {
			if(val != "L"){
				this.reliefApply.pensionValue = "";
			}
		}
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>
<style>
</style>
